import ApiRequest from "../utils/apiRequest"

export default class Utils {
  static uploadImage = async (body) => {
    return await ApiRequest.setMultipart("v1/upload/public/image", "POST", body)
  }
}